import { PetOnboarding } from './PetOnboarding';
import type { PrefillPetData } from '../context/AddPetModalContext';

interface AddPetModalProps {
  onClose: () => void;
  prefill?: PrefillPetData;
}

export function AddPetModal({ onClose, prefill }: AddPetModalProps) {
  return <PetOnboarding onClose={onClose} initiatedBy="owner" prefill={prefill} />;
}